
<span [class.currency-symbol]="symbolObj?.is_symbol" [innerHTML]="symbolObj?.symbol"></span>